import { useCallback } from "react";
import { createOpenBankingConsent } from "Shared/util/web-api";
import {
    AuthenticationFlowResource,
    ConsentResource,
    CreateConsentInputResource,
} from "Shared/util/types";
import { getUserAgentResource } from "Shared/util/user-agent";

export const useConsentCreater = (
    onCreated: (
        authenticationFlow: AuthenticationFlowResource,
        consent: ConsentResource,
    ) => void,
    onError: () => void,
    onFinally?: () => void,
): ((
    authenticationFlow: AuthenticationFlowResource,
    finaBankId: number,
    bic: string,
    socialSecurityNumber?: string,
    affiliatedBankId?: string,
) => void) =>
    useCallback(
        (
            authenticationFlow: AuthenticationFlowResource,
            finaBankId: number,
            bic: string,
            socialSecurityNumber?: string,
            affiliatedBankId?: string,
        ) => {
            const userAgent = getUserAgentResource();

            const payload: CreateConsentInputResource = {
                affiliatedBankId: affiliatedBankId,
                authenticationFlow,
                finaBankId,
                bic,
                socialSecurityNumber,
                userAgent,
            };

            createOpenBankingConsent(payload)
                .then((result: ConsentResource) =>
                    onCreated(authenticationFlow, result),
                )
                .catch(() => onError())
                .finally(() => onFinally?.());
        },
        [onCreated, onError, onFinally],
    );
